<script lang="ts">
  import {CatalystApp} from 'Catalyst/components/CatalystApp';
  import type {IconProps} from 'Catalyst/components/Icon';
  import {Icon} from 'Catalyst/components/Icon';
  import {whiteLabeling} from 'Store/WhiteLabelStore';
  import type {CssColor} from 'Catalyst/utility/theme';
  import type {IncentiveTier} from 'Types/incentiveTier/incentiveTierTypes';
  import {formatMerchandiseList} from 'Utility/deals/incentiveTiers/merchandiseList';

  export let listIcon: IconProps['name'];
  export let title: string = '';
  export let fundedBy: string = '';
  export let incentiveTiers: IncentiveTier | IncentiveTier[];
  export let excludeVolumeDiscount: boolean = false;

  $: brandColor = $whiteLabeling.primary_color as CssColor;
  $: benefits = formatMerchandiseList(incentiveTiers, excludeVolumeDiscount);
  $: hasItems = benefits && benefits.length > 0;
</script>

{#if hasItems}
  <CatalystApp
    brandColors={[
      {
        key: 'brand-color',
        value: brandColor,
      },
    ]}
  >
    <div data-testid="incentive-list">
      <p
        class="text-[0.875rem] font-medium leading-[1.25rem] text-left font-['Inter'] text-[#475467] mb-[0.5rem] card-title"
      >
        {title}
      </p>
      <ul>
        {#each benefits as item}
          <li
            class="flex items-center gap-[0.5rem] mb-[0.5rem]"
            data-testid="incentive-list-item"
          >
            <Icon
              class="text-[--palettes-brand-color-500] self-start"
              name={listIcon}
              size="20dp"
              density="compact"
              filled={true}
            />
            <span
              class="
              inline-block
              leading-none
              font-[Inter]
              text-[0.875rem]
              font-normal
              text-left
              [text-underline-position:from-font]
              [text-decoration-skip-ink:none]
              text-[#667085]
            "
            >
              {item}
            </span>
          </li>
        {/each}
      </ul>

      {#if fundedBy}
        <div class="mt-4">
          <p
            class="text-[0.75rem] font-medium leading-[1.25rem] text-left font-['Inter'] text-[#475467]"
          >
            *Funds must be received by {fundedBy}
          </p>
        </div>
      {/if}
    </div>
  </CatalystApp>
{/if}

<style>
  .card-title {
    display: none;
  }

  @container (min-width: 768px) {
    .card-title {
      display: block;
    }
  }
</style>
